<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>智能客服管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item prop="whitelisttags"
                          label="白名单标签">
              <el-select v-model="form.whitelisttags"
                         multiple
                         filterable
                         remote
                         reserve-keyword
                         placeholder="请输入关键词"
                         :remote-method="remoteMethodTag"
                         :loading="loading">
                <el-option v-for="item in tagOpts"
                           :key="item.id"
                           :label="item.tagname"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="task_hint_text"
                          label="新手任务跳转文案">
              <el-input v-model="form.task_hint_text" type="textarea"/>
            </el-form-item>
            <el-form-item prop="taskid"
                          label="新手跳转任务">
              <sj-remote-select
                class="width-max"
                clearable
                id-key="taskid"
                keyword-key="keyword"
                label-key="label"
                value-key="taskid"
                placeholder="输入关键字搜索"
                v-model="form.taskid"
                :remote-method="queryTaskTableWithLabel">
              </sj-remote-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         native-type="submit">提交表单
              </el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../intelligent-customer-service.rules'

export default {
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  data () {
    return {
      formRules,
      tagOpts: [],
      loading: false,
      form: {
        whitelisttags: [],
        task_hint_text: '',
        taskid: null,
      },
    }
  },
  methods: {
    ...request.map(['queryTaskTable', 'getUserTagTable', 'getUserTagDetail']),
    normalizeTaskId (value) {
      // el-select 对 value 采用严格相等匹配，避免 "123" 与 123 匹配不上
      if (value === null || value === undefined || value === '') return value
      const num = Number(value)
      return isNaN(num) ? value : num
    },
    queryTaskTableWithLabel (params) {
      const keyword = params && (params.keyword || params.key || params.q)
      const body = Object.assign({}, params || {})
      if (keyword !== undefined && keyword !== null && keyword !== '') {
        const keywordStr = String(keyword).trim()
        if (/^\d+$/.test(keywordStr)) {
          body.taskids = [Number(keywordStr)]
        } else {
          body.text = keywordStr
        }
      }
      // 编辑时，会传入taskid，这里需要转成taskids以支持任务ID查询
      if (body.taskid) {
        body.taskids = [Number(body.taskid)]
        delete body.taskid
      }
      body.current_page = body.current_page || 1
      body.per_page = body.per_page || 50
      return this.queryTaskTable(body).then((res) => {
        let items = _.get(res, 'data.data', [])
        if (!_.isArray(items) && items) items = [items]
        for (let i = 0; i < items.length; i++) {
          const item = items[i]
          if (!item) continue
          const title = item.title || ''
          if (item.taskid !== undefined) item.taskid = this.normalizeTaskId(item.taskid)
          const id = (item.taskid !== undefined ? item.taskid : (item.id || ''))
          item.label = title + '/' + id
        }
        return res
      })
    },
    onLoad () {
      this.setForm()
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm () {
      request.page('getIntelligentCustomerServiceConfig').then(({data}) => {
        filter.setLoop(this.form, data)
        this.form.taskid = this.normalizeTaskId(this.form.taskid)
        this.tagOpts = data.whitelisttags_arr || []
      })
    },
    getForm () {
      return filter.copyJson(this.form)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.update()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    update () {
      request.common('setIntelligentCustomerServiceConfig', {...this.getForm()}).then(() => {
        this.$confirm(this.$route.meta.title + '成功', '提示', {type: 'success'}).then(() => {
        })
      })
    },
    remoteMethodTag (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          request.alert('getUserTagName', {query: query}).then(({data}) => {
            this.tagOpts = data
            this.loading = false
          })
        }, 500)
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/intelligent-customer-service/pages/IntelligentCustomerServiceForm.vue